import React, { Component } from "react";
import Dimensions from "react-dimensions";
import { Table, Column, Cell } from "fixed-data-table-2";

const TransactionCell = ({ rowIndex, data, itemName, ...props }) => {
  return (
    <Cell {...props}>
      {data[rowIndex][itemName]}
      <br />
    </Cell>
  );
};

class Transactions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columnWidths: {
        identifier: 0.094,
        cardNumber: 0.11,
        holder: 0.23,
        brand: 0.078,
        tid: 0.15,
        proof: 0.075,
        code: 0.065,
        provider: 0.071,
        id: 0.0833,
        amount: 0.05,
        date: 0.0833,
        installments: 0.07,
        reversal: 0.07
      }
    };

    this.resizeCallback = this.resizeCallback.bind(this);
  }

  resizeCallback(newWidth, columnKey) {
    this.setState(({ columnWidths }) => ({
      columnWidths: {
        ...columnWidths,
        [columnKey]: newWidth / this.props.containerWidth
      }
    }));
  }

  render() {
    const tableData = this.props.tableData;
    const cw = this.props.containerWidth;
    const columnWidths = this.state.columnWidths;

    return (
      <Table
        rowHeight={50}
        groupHeaderHeight={50}
        headerHeight={50}
        rowsCount={tableData.length}
        width={cw}
        height={500}
        onColumnResizeEndCallback={this.resizeCallback}
        isColumnResizing={false}
      >
        <Column
          columnKey="holder"
          header={<Cell>Nome</Cell>}
          cell={<TransactionCell data={tableData} itemName="holder" />}
          width={cw * columnWidths.holder}
          minWidth={20}
          isResizable={true}
        />
        <Column
          columnKey="cardNumber"
          header={<Cell>Número</Cell>}
          cell={<TransactionCell data={tableData} itemName="cardNumber" />}
          width={cw * columnWidths.cardNumber}
          minWidth={20}
          isResizable={true}
        />
        <Column
          columnKey="brand"
          header={<Cell>s</Cell>}
          cell={<TransactionCell data={tableData} itemName="brand" />}
          width={cw * columnWidths.brand}
          minWidth={20}
          isResizable={true}
        />

        <Column
          columnKey="brand"
          header={<Cell>s</Cell>}
          cell={<TransactionCell data={tableData} itemName="brand" />}
          width={cw * columnWidths.brand}
          minWidth={20}
          isResizable={true}
        />
        <Column
          columnKey="asdsa"
          header={<Cell>s</Cell>}
          cell={<TransactionCell data={tableData} itemName="identifier" />}
          width={cw * columnWidths.brand}
          minWidth={20}
          isResizable={true}
        />
      </Table>
    );
  }
}
export default Dimensions({
  getHeight: function(element) {
    return window.innerHeight - 200;
  },
  getWidth: function(element) {
    var widthOffset = window.innerWidth < 768 ? 62 : 286;
    return window.innerWidth - widthOffset;
  }
})(Transactions);



// WEBPACK FOOTER //
// ./src/components/Transactions/index.js